export default __webpack_public_path__ + "static/media/logo-full-border.1936f9bd.svg";